import type { Item } from '@shared/types';

/**
 * Which catalog items to suggest when adding a line to an order mid-fulfillment.
 *
 * `catalog` is already scoped to the order's program by the caller, so the only
 * question left is channel:
 *
 * - **Vendor order** — only that vendor's items. The order becomes an emailed PO
 *   to one supplier, so suggesting things they don't stock is just a way to send
 *   a vendor a line they'll query.
 * - **Grocery order** — everything in the program. It's a shopping list a person
 *   carries into a store, and anything can be bought in person; a vendor-channel
 *   item picked up off the shelf is exactly the case worth supporting.
 *
 * This replaced a "Whole catalog" checkbox that only widened the *suggestions*
 * while the exact-name match always searched everything — so it never actually
 * constrained what could be added, and it unmounted itself when ticked.
 */
export function suggestionsFor(order: { channel: string; vendor_id: number | null }, catalog: Item[]): Item[] {
  if (order.channel !== 'vendor') return catalog;
  return catalog.filter((i) => i.fulfillment_channel === 'vendor' && i.vendor_id === order.vendor_id);
}
